import * as React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { DeleteWarningIcon } from "../../../components/ui/icons";
import { IUserGuide } from "../userGuideTypes";

interface IDeleteUserGuideModalProps {
  show: boolean;
  selectedGuide: IUserGuide | null;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const DeleteUserGuideModal = ({
  show,
  selectedGuide,
  isDeleting,
  onClose,
  onConfirm,
}: IDeleteUserGuideModalProps) => {
  return (
    <Modal
      show={show}
      onHide={isDeleting ? undefined : onClose}
      className="modal-container user-guide-delete-modal"
      centered
    >
      <Modal.Header closeButton={!isDeleting}>
        <Modal.Title>
          <div className="delete-heading">
            <DeleteWarningIcon />
            <h1>Delete</h1>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          Are you sure you want to delete the{" "}
          <strong>{selectedGuide?.title || "selected"}</strong> help guide?
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button className="btn-cancel" disabled={isDeleting} onClick={onClose}>
          Cancel
        </Button>

        <Button
          className="btn-delete"
          disabled={isDeleting}
          onClick={onConfirm}
        >
          {isDeleting && <Spinner animation="border" size="sm" />}
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteUserGuideModal;